module.exports = __webpack_public_path__ + "img/ico_calendar--wh.4de346d7.svg";